import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import {
  AlphaChannel,
  ColorMode,
  DialogDisplay,
  OutputFormat,
  PositionDialog,
} from "./tya-color-picker.data";

@Component({
  selector: "tya-color-picker",
  templateUrl: "./tya-color-picker.component.html",
  styleUrls: ["./tya-color-picker.component.scss"],
})
export class TyaColorPickerComponent implements OnInit {
  @Input() color: string = "#000000";
  @Input() fallbackColor: string = "#000";
  @Input() presetLabel: string = "Preset colors";

  @Input() presetColors: string[] = [];

  @Input() colorMode: string = ColorMode.Color;
  @Input() defaultFormat: string = OutputFormat.Auto;
  @Input() alphaChannel: string = AlphaChannel.Enabled;
  @Input() position: string = PositionDialog.Auto;
  @Input() dialogDisplay: string = DialogDisplay.Popup;

  @Input() width: number = 300;
  @Input() height: number = 300;
  @Input() positionOffset: number = 0;

  @Input() fullWidth: boolean = false;
  @Input() isCmyk: boolean = false;
  @Input() isToggle: boolean = false;
  @Input() isDisabled: boolean = false;

  @Output() colorPickerOpen = new EventEmitter<string>();
  @Output() colorPickerClose = new EventEmitter<string>();
  @Output() colorPickerChange = new EventEmitter<string>();
  @Output() colorPickerCancel = new EventEmitter();
  @Output() colorPickerSelect = new EventEmitter<string>();
  @Output() toggleChange = new EventEmitter<boolean>();
  @Output() inputChange = new EventEmitter<{
    input: string;
    value: number | string;
    color: string;
  }>();
  @Output() sliderChange = new EventEmitter<{
    slider: string;
    value: number | string;
    color: string;
  }>();
  @Output() sliderDragStart = new EventEmitter<{
    slider: string;
    color: string;
  }>();
  @Output() sliderDragEnd = new EventEmitter<{
    slider: string;
    color: string;
  }>();
  @Output() cmykColorChange = new EventEmitter<string>();

  valuePositionOffset: string;

  constructor() {}

  ngOnInit(): void {
    this.valuePositionOffset = `${this.positionOffset}%`;

    if (this.presetColors.length > 0 && this.height < 350) {
      this.height = 350;
    }
  }
}
